<div class="row">
  <div class="col-12">
    <div class="content-header">Transaction Form</div>
  </div>
</div>
<!-- Basic Inputs start -->
<section id="basic-input">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <!-- <div class="card-header">
					<h4 class="card-title">Basic</h4>
				</div> -->
        <div class="card-content">
          <div class="card-body">
            <div class="row">
              <div class="col-md">
                <form [formGroup]="transactionForm">
                  <fieldset class="form-group">
                    <label for="name">Amount</label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="amount"
                      id="amount"
                      placeholder="Enter amount"
                      [ngClass]="{
                        'is-invalid': transactionFormSubmitted && rf.amount.invalid,
                        'is-valid': transactionFormSubmitted && !rf.amount.invalid
                      }"
                      required
                    />
                    <div
                      *ngIf="
                        rf.amount.touched &&
                        (rf.amount.invalid || rf.amount.errors?.required)
                      "
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> Amount is
                      required
                    </div>
                  </fieldset>
                  <fieldset class="form-group">
                    <label class="form-control-label" for="status"
                      >Payment Mode</label
                    >
                    <ng-select
                      [items]="paymentMode"
                      bindLabel="displayname"
                      bindValue="_id"
                      placeholder="Select Payment Mode"
                      [(ngModel)]="selectedPaymentMode"
                      [ngModelOptions]="{ standalone: true }"
                      (change)="getPaymentModeId($event)"
                    >
                    </ng-select>
                </fieldset>
                  <fieldset class="form-group">
                    <label for="name">User</label>
                    <select
                      id="category"
                      class="form-control"
                      [(ngModel)]="selectedValue"
                      [ngModelOptions]="{ standalone: true }"
                      (change)="getUserId($event)" >
                      <option value="" disabled>
                        Select User
                      </option>
                      <option
                        *ngFor="let user of users"
                        [value]="user._id"
                      >
                        {{ user.name }}
                      </option>
                    </select>
                  </fieldset>
                  <div
                    class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-3 mt-sm-2"
                  >
                    <button
                      type="submit"
                      class="btn btn-primary mb-2 mb-sm-0 mr-sm-2"
                      (click)="submit()"
                    >
                      Submit
                    </button>
                    <button
                      type="reset"
                      class="btn btn-secondary"
                      (click)="back()"
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
